import { Coffee, Flag, UtensilsCrossed } from 'lucide-react';

import { breakKindOf } from './breakKind';

export interface BreakIconProps {
  /** The institute's own name for the break — "Lunch break", "Morning assembly". */
  label: string | null | undefined;
  /** Size and colour, which each grid sets to suit its own band. */
  className?: string;
}

/**
 * The mark on a break band: a plate for lunch, a flag for assembly, a cup for
 * any other break.
 *
 * One picture per kind in one place, beside `breakKindOf` — the office's grid,
 * the parent's and the teacher's each chose their own once, and lunch ended up
 * drawn two different ways (CLAUDE.md §3).
 */
export function BreakIcon({ label, className }: BreakIconProps) {
  const kind = breakKindOf(label);
  const Icon = kind === 'LUNCH' ? UtensilsCrossed : kind === 'ASSEMBLY' ? Flag : Coffee;
  return <Icon className={className} aria-hidden />;
}
